module.exports = __webpack_public_path__ + "img/share.1afbe8c7.svg";